import * as React from "react";
import { cn } from "@/lib/utils";

export interface FormDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string;
}

export const FormDivider: React.FC<FormDividerProps> = ({
  text = "or",
  className,
  ...props
}) => {
  return (
    <div
      className={cn("relative flex items-center justify-center h-5", className)}
      {...props}
    >
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-black/[0.08] dark:border-white/10" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-transparent px-4 text-text-quaternary">{text}</span>
      </div>
    </div>
  );
};

export default FormDivider;
